module.exports = __webpack_public_path__ + "img/placeH.5acdfc7a.png";